import { __assign, __rest } from "tslib";
import React from 'react';
import GhostButton from '../../../../../Buttons/GhostButton';
var DestructiveConfirmButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(GhostButton, __assign({ size: "large", variant: "destructive-red" }, rest), children));
};
DestructiveConfirmButton.displayName = 'DestructiveConfirmButton';
export default DestructiveConfirmButton;
//# sourceMappingURL=DestructiveConfirmButton.js.map